import { ES10nSettings } from '@unikey/unikey-commons/release/comm';
import { api, environment } from '@alias-environment';

export const s10n = (subscriptionSetting: ES10nSettings, ...args: any): boolean => {
  return api.getS10nModel().allowed(subscriptionSetting);
};
